"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useMeasure_1 = __importDefault(require("@empiriecom/module-components/hooks/useMeasure"));
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var useConfig_1 = __importDefault(require("../../hooks/useConfig"));
var Page1_1 = __importDefault(require("./Page1"));
var Page2_1 = __importDefault(require("./Page2"));
var ContentBody = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  // this border is the bottom-buffer-range for content changes - this keeps the background-color for shrinking content\n  border-bottom: 12.5rem solid ", ";\n\n  @media only screen and (min-width: ", ") {\n    border-top: 0.125rem solid ", ";\n  }\n\n  padding: 1rem;\n  > div {\n    max-width: 40rem;\n    margin-left: auto;\n    margin-right: auto;\n  }\n"], ["\n  background-color: ", ";\n  // this border is the bottom-buffer-range for content changes - this keeps the background-color for shrinking content\n  border-bottom: 12.5rem solid ", ";\n\n  @media only screen and (min-width: ",
    ") {\n    border-top: 0.125rem solid ", ";\n  }\n\n  padding: 1rem;\n  > div {\n    max-width: 40rem;\n    margin-left: auto;\n    margin-right: auto;\n  }\n"])), function (_a) {
    var greyLight = _a.theme.greyLight;
    return greyLight.color.normal;
}, function (_a) {
    var greyLight = _a.theme.greyLight;
    return greyLight.color.normal;
}, function (_a) {
    var desktopminwidth = _a.desktopminwidth;
    return desktopminwidth;
}, function (_a) {
    var primary = _a.theme.primary;
    return primary.color.normal;
});
var SheetContent = function (_a) {
    var _b;
    var isSheetOpen = _a.isSheetOpen, sheetContentHeightSetup = _a.sheetContentHeightSetup;
    var setCurrentSheetContentHeight = sheetContentHeightSetup.setCurrentSheetContentHeight;
    var _c = react_1.useState(1), page = _c[0], setPage = _c[1];
    var config = useConfig_1.default();
    var desktopMinWidth = ((_b = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _b === void 0 ? void 0 : _b.values).desktopMinWidth;
    var _d = useMeasure_1.default(), refBody = _d[0], contentHeight = _d[1].height;
    setCurrentSheetContentHeight(isSheetOpen ? contentHeight - 175 : 2);
    var PageContent = page === 1 ? react_1.default.createElement(Page1_1.default, { setPage: setPage }) : react_1.default.createElement(Page2_1.default, null);
    return (react_1.default.createElement("div", { ref: refBody },
        ' ',
        react_1.default.createElement(ContentBody, { desktopminwidth: desktopMinWidth }, PageContent)));
};
exports.default = SheetContent;
var templateObject_1;
//# sourceMappingURL=Content.js.map